// src/pages/home/home.jsx
import React, { useContext } from 'react';
import { Routes, Route, Link } from 'react-router-dom';
import Navbar from '../../components/navbar/navbar';
import Consult from '../consult/consult';
import Dashboard from '../dashboard/dashboard';
import PreCalculation from '../calculation/pre_calculation';
import CalculationForm from '../calculation/calculation';
import AuthContext from '../../context/Auth/AuthContext';
import Footer from '../../components/footer/footer';
import DashboardRRA from '../calculation/dashboard/cal_dash';
import MiniDashboardRelatorio from '../../components/mini-dashboard/MiniDashboardRelatorio';
import MiniDashboardCalculo from '../../components/mini-dashboard/MiniDashboardCalculo';
import calcStyles from '../calculation/calculation.module.css'; // reutiliza a borda/legend dos cards
import './home.css';

const Home = () => {
  const { user } = useContext(AuthContext);

  // se veio { message, user: { … } }, pega esse .user
  const actualUser = user?.user ?? user;

  // pega o full_name (como no seu log) 
  const displayName = actualUser?.full_name ?? 'Usuário';

  return (
    <div className="home-container">
      <Navbar />
      <div className="content">
        <Routes>
          <Route path="consult" element={<Consult />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="calculation" element={<PreCalculation />} />
          <Route path="calculation/manual" element={<CalculationForm />} />
          <Route path="calculos" element={<DashboardRRA />} />
          <Route
            index
            element={
              <>
                <h1>Bem-vindo(a), {displayName}</h1>

                {/* Wrapper em grid para dividir esquerda/direita */}
                <div className="home-sections-row">

                  {/* Esquerda: Certidão */}
                  <section className="home-section">
                    <fieldset className={`section-fieldset ${calcStyles.fieldset}`}>
                      <legend className="section-legend">
                        <span>Certidão</span>
                        <div className="quickLinks">
                          <Link className="linkBtn" to="/home/consult">Solicitar</Link>
                          <Link className="linkBtn" to="/home/dashboard">Relatório</Link>
                        </div>
                      </legend>
                      <MiniDashboardRelatorio />
                    </fieldset>
                  </section>

                  {/* Direita: Cálculo de Precatório */}
                  <section className="home-section">
                    <fieldset className={`section-fieldset ${calcStyles.fieldset}`}>
                      <legend className="section-legend">
                        <span>Cálculo de Precatório</span>
                        <div className="quickLinks">
                          <Link className="linkBtn" to="/home/calculation">Solicitar</Link>
                          <Link className="linkBtn" to="/home/calculos">Relatório</Link>
                        </div>
                      </legend>
                      <MiniDashboardCalculo />
                    </fieldset>
                  </section>

                </div>
              </>
            }
          />
        </Routes>
      </div>
      <Footer />
    </div>
  );
};

export default Home;
